module.exports = __webpack_public_path__ + "img/0Q3A4053_L_BlackMatted_MockedUp.7a2ce41c.jpg";